/**
 * Deleting a cellar's contents from outside that cellar (T074: own settings, the owner's people
 * screen). Loads the latest document and saves it emptied with the usual conditional write, so a
 * change made meanwhile on another device is not silently overwritten
 * (contracts/storage-and-permissions.md "Emptying a cellar").
 */
import { emptyCellar } from '../domain/cellar';
import { CellarNotFoundError, createCellarStore } from './cellar-store';
import type { ObjectStorage } from './fake-storage';

export async function deleteCellarContents(
  storage: ObjectStorage,
  cellarId: string,
): Promise<'emptied' | 'missing'> {
  const store = createCellarStore(storage, cellarId, { createIfMissing: false });
  try {
    await store.load();
  } catch (error) {
    if (error instanceof CellarNotFoundError) return 'missing';
    throw error;
  }
  await store.apply(emptyCellar);
  return 'emptied';
}
